import * as React from 'react';

import { Box, SvgButton, color } from '@coursera/coursera-ui';
import { SvgFacebook } from '@coursera/coursera-ui/svg';

import { THIRD_PARTY_AUTH_METHODS } from 'bundles/authentication/shared/components/third-party-auth/constants';
import withSocialAuthControls from 'bundles/authentication/shared/components/third-party-auth/withSocialAuthControls';
import withSingleTracked from 'bundles/common/components/withSingleTracked';

import _t from 'i18n!nls/authentication';

const TrackedSvgButton = withSingleTracked({ type: 'BUTTON' })(SvgButton);

const CONFIG = {
  facebookDisabledBgColor: '#f5f5f5',
  facebookDisabledOutlineColor: '#dbdbdb',
  facebookColor: '#3b5998',
};

type Props = {
  onSuccess: (response?: unknown) => void;
};

const FacebookAlternative = ({ onSuccess }: Props) => (
  <Box
    rootClassName="FacebookAlternative"
    flexDirection="column"
    htmlAttributes={{ 'data-e2e': 'c-user-modal-facebook-button' }}
  >
    <TrackedSvgButton
      trackingName="continue_with_facebook_auth_btn"
      type="primary"
      onClick={onSuccess}
      label={_t('Continue with Facebook')}
      svgElement={<SvgFacebook size={18} color={CONFIG.facebookColor} />}
      style={{
        backgroundColor: color.white,
        borderColor: CONFIG.facebookColor,
        color: CONFIG.facebookColor,
        fontWeight: 'bold',
        padding: '0.6rem',
        transition: 'background-color 250ms ease-out, border-color 250ms ease-out',
      }}
    />
  </Box>
);

export default withSocialAuthControls(FacebookAlternative, THIRD_PARTY_AUTH_METHODS.FACEBOOK);
